<button
  *ngIf="xeroPermission && xeroAccount?.isIntegrated"
  type="button"
  class="document-action"
  (click)="exportToXero()"
>
  {{ 'ACTION.EXPORT_TO_XERO' | translate }}
</button>
